export default "__VITE_ASSET__7df75e07__"